export async function requestJson(url: string) {
    const requestOptions = {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
    };

    const response = await fetch(url, requestOptions);

    if (response.ok) {
        const responseJson = await response.text();
        return JSON.parse(responseJson);
    } else {
        return null;
    }

}

export async function requestProjectJson(url: string, body?: object) {
    const requestOptions = {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(body),
    };

    const response = await fetch(url, requestOptions);

    if (response.ok) {
        const responseJson = await response.text();
        return JSON.parse(responseJson);
    } else {
        return null;
    }

}

export async function requestJsonGet(url: string) {
    const requestOptions = {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
        },
    };

    const response = await fetch(url, requestOptions);
    const responseJson = await response.text();
    return JSON.parse(responseJson);
}
